<template>
    <div class="templete_box">
        <navTab :navlist="navlist" :nav-index="tab"  :templateName="'bankingPayableRedeemList'" @reback="res=>{this.tab = res;}"></navTab>
        <lookCargo @child-num='emitNum' v-if="Number(tab) === 0"></lookCargo>
        <cargoFlow @child-num='emitNum' v-if="Number(tab) === 1"></cargoFlow>
    </div>
</template>
<script>
    import lookCargo from './components/lookCargo';
    import cargoFlow from './components/cargoFlow';
    export default {
        data(){
            return{
                navlist:['查看货权','货权流水'],
                tab:1,
                saleNum:''
            }
        },
        created(){
            if(sessionStorage.TOADVANCE){
                this.tab=Number(sessionStorage.TOADVANCE);
                sessionStorage.removeItem("TOADVANCE")
            }else{
                this.tab=0;
            }
            // this.emitNum()
        },
        methods:{
            emitNum(data){
                // this.saleNum = data;
                // this.navlist = ['销售赎货'+'('+ data.sales_count+')','提前赎货'+'('+ data.advance_count+')']
            }
        },
        components:{
            lookCargo,
            cargoFlow
        }
    }
</script>
<style scoped>

</style>